"use client";
import clsx from "clsx";
import { PrismicNextLink } from "@prismicio/next";
import React, { useState } from "react";
import { IoChevronDown } from "react-icons/io5";

/**
 * @typedef {import("@prismicio/client").Content.MenuItemSlice} MenuItemSlice
 * @typedef {import("@prismicio/react").SliceComponentProps<MenuItemSlice>} MenuItemProps
 * @param {MenuItemProps}
 */
const MenuItem = ({ slice, currentPageUid }) => {
  const link = slice?.primary?.link;
  const label = slice?.primary?.label;
  const [menuOpened, setMenuOpened] = useState(false);

  const dropdown = slice?.primary?.dropdown || [];

  const hasActiveSubmenu = dropdown.find(
    (item) => item.link?.uid === currentPageUid,
  );

  const isActiveMenu =
    currentPageUid === slice.primary?.link?.uid || hasActiveSubmenu;

  return (
    <li
      className={clsx({
        "relative text-slate-800 pointer-events-auto main-nav-item text-button": true,
        "py-3 w-full xl:w-auto": true,
        "items-center justify-center": true,
      })}
      onMouseEnter={() => setMenuOpened(true)}
      onMouseLeave={() => setMenuOpened(false)}
    >
      <div
        className={clsx({
          "bg-primary absolute active-menu-bar pointer-events-none": true,
          hidden: !isActiveMenu,
          "hidden xl:block": isActiveMenu,
        })}
      />
      <PrismicNextLink
        field={link}
        className={clsx({
          "relative w-full flex items-center": true,
          "active-main-nav-link": isActiveMenu,
          "text-white": !isActiveMenu,
        })}
      >
        <span className={"!block xl:!pr-2"}>{label}</span>
        {dropdown?.length ? (
          <button
            onClick={(e) => {
              e.stopPropagation();
              e.preventDefault();
              setMenuOpened(!menuOpened);
            }}
            className={"ms-2 xl:ms-auto block"}
            aria-label="Toggle dropdown"
            style={{ padding: "0 3px" }}
          >
            <IoChevronDown size={18} />
          </button>
        ) : null}
      </PrismicNextLink>
      {dropdown?.length ? (
        <ul
          className={`${clsx({
            "main-nav-dropdown-links-wrapper  xl:grid-cols-2": true,
          })}
          ${menuOpened ? "block xl:grid" : "hidden"}
          `}
          // style={{ display: menuOpened ? "block" : "none" }}
        >
          <div>
            {dropdown.map((item, idx) => {
              const isActiveSubMenu = currentPageUid === item?.link?.uid;
              if (idx < Math.ceil(dropdown?.length / 2)) {
                return (
                  <li key={idx}>
                    <PrismicNextLink
                      field={item?.link}
                      className={clsx({ "active-submenu": isActiveSubMenu })}
                    >
                      {item?.label}
                    </PrismicNextLink>
                  </li>
                );
              }
            })}
          </div>
          <div>
            {dropdown?.map((item, idx) => {
              const isActiveSubMenu = currentPageUid === item?.link?.uid;
              if (idx >= Math.ceil(dropdown.length / 2)) {
                return (
                  <li key={idx}>
                    <PrismicNextLink
                      field={item.link}
                      className={clsx({ "active-submenu": isActiveSubMenu })}
                    >
                      {item.label}
                    </PrismicNextLink>
                  </li>
                );
              }
            })}
          </div>
        </ul>
      ) : null}
    </li>
  );
};

export default MenuItem;
